const initialState = [];

export default function segment(state = initialState, action) {
  switch (action.type) {
    case 'SET_REGION_SEGMENT':
      return action.payload;
    default:
      return state;
  }
}